import request from '@/utils/request'
import {
  ResponseGetHomeStats,
  ResponseGetHomeTodoOrder,
  ResponseGetScwProduct,
  ResponseGetCallNotice,
  ResponseGetLeyoPayData,
  ResponseSrmUserInfo,
  ParamsMarkOrderTodoRead,
  ResponseGetQuoteBoardSummary,
  ResponseGetHomeChannelList,
  ResponseGetHomeUnInvoiceCount,
  ResponseGetNewbieFinish,
  ParamsSetNewbieFinish
} from './type'

export function getHomeStats(): Promise<ResponseGetHomeStats> {
  return request.post({
    url: '/home/stats'
  })
}

export function getHomeTodoOrder(): Promise<ResponseGetHomeTodoOrder> {
  return request.post({
    url: '/home/todo/order'
  })
}

export function getScwProduct(): Promise<ResponseGetScwProduct> {
  return request.post({
    url: '/home/todo/scwProduct'
  })
}

export function markOrderTodoRead(params: ParamsMarkOrderTodoRead): Promise<void> {
  return request.post({
    url: '/home/todo/order/markRead',
    params
  })
}

/** 首页报价公告-聚合 */
export function getQuoteBoard(): Promise<ResponseGetCallNotice> {
  return request.post({
    url: '/home/todo/quoteBoard'
  })
}
/** 首页报价公告摘要 */
export function getQuoteBoardSummary(): Promise<ResponseGetQuoteBoardSummary> {
  return request.post(
    {
      url: '/web/enquiry/quoteBoardSummary/scw3130'
    },
    {
      apiUrl: 'scw-leyo'
    }
  )
}

/** 报价公告代办消除 */
export function markQuoteBoardTodoRead(): Promise<void> {
  return request.post(
    {
      url: '/web/enquiry/quoteBoardReminderRead/scw3130'
    },
    {
      apiUrl: 'scw-leyo'
    }
  )
}

/** 首页未开票数量统计 */
export function getHomeUnInvoiceCount(): Promise<ResponseGetHomeUnInvoiceCount> {
  return request.post(
    {
      url: '/web/invoice/notInvoiceBatchStats/scw3100'
    },
    {
      apiUrl: 'scw-leyo'
    }
  )
}

/** 首页渠道列表 */
export function getHomeChannelList(): Promise<ResponseGetHomeChannelList> {
  return request.post({
    url: '/home/channelUserList'
  })
}

/** 直接使用gys的接口 */
/**
 * [srm] - 已授权状态首页结算系统数据
 */
export function getLeyoPayData(): Promise<ResponseGetLeyoPayData> {
  return request.post(
    {
      url: '/auth/get-leyo-pay-data/v100'
    },
    {
      apiUrl: 'gys-web',
      useAuthorization: true,
      ignoreError: true,
      errorMessageMode: 'none'
    }
  )
}

/**
 * [srm] - 账号权限和用户信息
 */
export function getSrmUserInfo(): Promise<ResponseSrmUserInfo> {
  return request.post(
    {
      url: '/auth/index/v100'
    },
    {
      apiUrl: 'gys-web',
      useAuthorization: true,
      ignoreError: true,
      errorMessageMode: 'none'
    }
  )
}

/**
 * [srm] - 获取新手指引是否已经完成
 */
export function getNewbieFinish(): Promise<ResponseGetNewbieFinish> {
  return request.post(
    {
      url: '/auth/isupplierNewbieGuideStatus/v100'
    },
    {
      apiUrl: 'gys-web',
      useAuthorization: true,
      ignoreError: true,
      errorMessageMode: 'none'
    }
  )
}

/**
 * [srm] - 设置新手指引是否已经完成
 */
export function setNewbieFinish(params: ParamsSetNewbieFinish): Promise<void> {
  return request.post(
    {
      url: '/auth/newbieFinish/v100',
      data: params
    },
    {
      apiUrl: 'gys-web',
      useAuthorization: true,
      ignoreError: true,
      errorMessageMode: 'none'
    }
  )
}
